<template>
    <ion-page>
        <ion-content>
            <ion-grid>
                <ion-row class="content-row" align-items-center>
                    <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                        <ion-img class="logo" :src="require('@/assets/logo_full_small.png')"></ion-img>
                        <ion-card class="login">
                            <ion-card-header>
                                <ion-card-title>{{ $t('screens.splash.title') }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content>
                                <ion-item>
                                    <ion-icon name="mail" color="medium"></ion-icon>
                                    <ion-input :placeholder="$t('screens.splash.placeholder-email')" type="email" :value="email" @input="email = $event.target.value" @keyup.enter="signIn"></ion-input>
                                </ion-item>
                                <ion-item v-if="!forgotForm">
                                    <ion-icon name="lock" color="medium"></ion-icon>
                                    <ion-input :placeholder="$t('screens.splash.placeholder-password')" type="password" :value="password" @input="password = $event.target.value" @keyup.enter="signIn"></ion-input>
                                </ion-item>
                                <ion-label color="danger" v-if="error">{{error}}</ion-label>
                                <ion-label color="danger" v-if="loginFailed">{{ $t('screens.splash.login-failed') }} <a href="#pwdForgot" @click="showForgotForm">{{ $t('screens.splash.click-here') }}</a></ion-label>
                                <ion-button expand="block" @click="signIn" type="submit" v-if="!forgotForm">{{ $t('screens.splash.login') }}</ion-button>
                                <ion-button expand="block" @click="resetPassword" type="submit" v-else>{{ $t('screens.splash.reset-password') }}</ion-button>
                                <div class="divider">{{ $t('screens.splash.or') }}</div>
                                <ion-button expand="block" class="fb" @click="fbLogin"><ion-icon name="logo-facebook"></ion-icon>{{ $t('screens.splash.login-with') }} Facebook</ion-button>
                                <!--<ion-button expand="block" class="google" @click="googleLogin"><ion-icon name="logo-google"></ion-icon>{{ $t('screens.splash.login-with') }} Google</ion-button>-->
                            </ion-card-content>
                        </ion-card>
                        <ion-label>- {{ $t('screens.splash.or') }} -</ion-label>
                        <ion-card class="signup">
                            <ion-card-header>
                                <ion-card-title>{{ $t('screens.splash.new-passenger') }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content>
                                <ion-button size="default" @click="$router.push('/signup')">{{ $t('screens.splash.signup') }}</ion-button>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
import validate from '@/validate';

export default {
    name: 'signin',
    data() {
        return {
            email: '',
            password: '',
            error: false,
            loggingIn: false,
            timeout: 10000,
            loadingScreen: false,
            loginFailed: false,
            forgotForm: false
        }
    },
    methods: {
        signIn: async function() {
            if (!this.email || !this.password) {
                this.error = this.$t('screens.splash.email-password-blank');
            } else if (!validate.email(this.email)) {
                this.error = this.$t('screens.splash.email-invalid');
            } else {
                // TODO: [security] Create custom cognito auth lambda to avoid 'UserNotFoundException' returned
                // https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-user-pool-managing-errors.html
                this.error = false;
                this.loggingIn = true;
                try {
                    const user = await this.$Amplify.Auth.signIn(this.email, this.password);
                    this.$logger.debug('login successful', user);
                    this.$AmplifyEventBus.$emit('authState', 'signedIn');
                    this.loggingIn = false;
                } catch(err) {
                    this.$logger.debug('login fail', err);
                    this.loggingIn = false;
                    this.loginFailed = true;
                }
            }
        },
        fbLogin: async function() {
            this.loggingIn = true;
            return this.$Amplify.Auth.federatedSignIn({provider:'Facebook'});
        },
        googleLogin: async function() {
            this.loggingIn = true;
            return this.$Amplify.Auth.federatedSignIn({provider:'Google'});
        },
        showLoginForm: function() {
            this.forgotForm = false;
            this.error = false;
        },
        showForgotForm: function() {
            this.loginFailed = false;
            this.error = this.$t('screens.splash.reset-pass-instructions');
            this.forgotForm = true;
        },
        resetPassword: function() {
            this.$Amplify.Auth.forgotPassword(this.email).then(data => {
                this.$logger.debug(data);
                this.error = this.$t('screens.splash.reset-pass-done');
            }).catch(err => {
                this.$logger.debug(err);
                this.error = this.$t('screens.splash.reset-pass-email-wrong');
            });
        }
    },
    beforeDestroy() {
        //the watcher gets destroyed too fast so we need to dismiss the loading here just in case
          if (this.loadingScreen) {
              this.loadingScreen.dismiss();
          }
    },
    watch: {
        loggingIn: function(val) {
            if (val) {
                this.$ionic.loadingController.create({
                    message: this.$t('screens.splash.logging-in'),
                    duration: this.timeout,
                }).then(l => {
                    this.loadingScreen = l;
                    l.present();
                    l.onDidDismiss().then(() => {
                        this.loadingScreen = false;
                    });
                });
            } else {
                this.loadingScreen.dismiss();
            }
        }
    }
}
</script>

<style scoped>
ion-content {
    --background: url('~@/assets/bg/bg9.jpg') no-repeat center center / cover;
}

ion-grid {
    height: 100%;
    font-family: 'Nunito', sans-serif;
    padding: 1em;
}

ion-input {
    margin-left: .5em;
}

ion-item {
    --background: rgba(255,255,255,.6);
    width: 98%;
    margin-left: 1%;
    margin-bottom: .5em;
}

ion-button {
    margin-top: 1em;
}

ion-label {
    font-family: 'Nunito', sans-serif;
    color: #fff;
    padding: .25em 0;
    display: block;
}

ion-card-header {
    --background: none;
}

ion-card {
    --background: rgba(255,255,255,.8);
    font-family: 'Nunito', sans-serif;
}

ion-card-title {
    --color: #333;
    font-size: 2.5em;
    font-weight: bold;
}

ion-col {
    padding: 0;
}

.signup {
    --background: rgba(255,255,255,.6);
}

.signup ion-card-title {
    font-size: 2em;
}

.signup ion-button {
    margin-top: 0;
}

.divider {
    margin: 0 auto;
    font-size: .8em;
}

.fb {
    --background: #3b5998;
    --background-hover: #8b9dc3;
    margin-top: .3em;
}

.fb ion-icon {
    margin-right: .5em;
}

.google {
    --background: #fff;
    --background-hover: #fff;
    color: #666;
    margin-top: .3em;
}

.google ion-icon {
    color: #dd4b39;
    margin-right: .5em;
}
</style>